import { useCreate, useOne, useParse } from "@refinedev/core";
import {
  AdditionalSetup,
  BuildEventPageStep,
  CreateTicketPhase,
  CreateUsuallyTypeTicket,
  ParticipantTemplatesStep,
} from "./components";
import { CreateEventStep, EventType, FrequencyOfSellType } from "interfaces";
import { FullScreenLoading } from "components/fullScreenLoading";
import { HistoryLogButton } from "components/historyLogButton";
import Button from "components/button";
import { get } from "lodash";
import { _openUrlOnNewTab } from "utills/helpers";
import { CreateSeatmapTicket } from "./components/steps/createSeatmapTicket";
import { StepsMenu } from "components/shared/event";

export const EditAttractionEvent: React.FC = () => {
  const parse = useParse();
  const { params } = parse();
  const { mutate: createMutation } = useCreate();

  const { data, refetch, isLoading } =
  useOne<any>({
    resource: "content/events",
    id: `${params?.id}${Number(params?.step) === CreateEventStep.BUILD_EVENT_PAGE ? "" : "?simple=true"}`,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!(params?.step && params?.id),
    } as any,
  });

  const eventDetailData = data?.data;

  const renderStep = (eventDetailData: any) => {
    const step = Number(params?.step ?? 1);
    if (step <= (eventDetailData.current_step + 1)) {
      switch (step) {
        case CreateEventStep.BUILD_EVENT_PAGE:
          return <BuildEventPageStep eventDetailData={eventDetailData} />;
        case CreateEventStep.PARTICIPANT_TEMPLATE:
          return <ParticipantTemplatesStep eventDetailData={eventDetailData} refetchEventDetail={refetch} />;
        case CreateEventStep.CREATE_TICKET_PHASE:
          return get(eventDetailData, "frequency_of_sell", "") === FrequencyOfSellType.ONCE 
            ? <CreateTicketPhase eventDetailData={eventDetailData} refetchEventDetail={refetch} /> 
            : get(eventDetailData, "frequency_of_sell", "") === FrequencyOfSellType.SEATMAP 
              ? <CreateSeatmapTicket eventDetailData={eventDetailData} refetchEventDetail={refetch} /> 
              : <CreateUsuallyTypeTicket eventDetailData={eventDetailData} refetchEventDetail={refetch} />;
        case CreateEventStep.ADDITIONAL_SETUP:
          return <AdditionalSetup eventDetailData={eventDetailData} refetchEventDetail={refetch} />;
        case CreateEventStep.PUBLISH:
          return <></>;
        default:
          return <></>;
      }  
    }
    return <></>;
  };

  const _redirectPreviewPage = (eventId: string) => {
    createMutation(
      {
        resource: "content/events/preview",
        meta: {
          ignoreResourceWrapper: true,
        },
        values: {
          event_id: eventId
        },
      },
      {
        onSuccess: (data) => {
          const previewUrl = get(data, "data.data.preview_url", "/");
          _openUrlOnNewTab(previewUrl);
        },
      }
    );
  }
  
  if (isLoading) {
    return <FullScreenLoading />;
  }
  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="shrink-0">
        <StepsMenu currentStep={eventDetailData?.current_step ?? 1} eventType={EventType.ATTRACTION} />
      </div>
      <div className="flex-1">
        {eventDetailData ? (
          <div>
            <div className="flex justify-between items-center gap-x-2 mb-4">
              <p className="font-medium">{eventDetailData?.name?.en ?? eventDetailData?.name[Object.keys(eventDetailData.name)[0] ?? "en"] ?? ""} </p>
              <div className="flex items-center gap-x-3">
                <Button 
                  className="text-sm w-fit border-solid border-brand-500 border-[1px] py-2"
                  onClick={() => _redirectPreviewPage(eventDetailData?.id ?? "")}
                >
                  Preview
                </Button>
                {Number(params?.step) !== CreateEventStep.PARTICIPANT_TEMPLATE ? (
                  <HistoryLogButton 
                    id="event-step"
                    resource={`content/events/${eventDetailData?.id}/steps/${params?.step}/history`}
                    className="py-1.5"
                  />
                ) : <></>}
              </div>
            </div>
            {renderStep(eventDetailData)}
          </div>
      ) : ""}</div>
    </div>
  );
};
